/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryGetUserMetricsSummary } from "../funcs/telemetryGetUserMetricsSummary.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetUserMetricsSummaryResult } from "../models/components/getusermetricssummaryresult.js";
import {
  GetUserMetricsSummaryRequest,
  GetUserMetricsSummarySecurity,
} from "../models/operations/getusermetricssummary.js";
import { unwrapAsync } from "../types/fp.js";
export type GetUserMetricsSummaryQueryData = GetUserMetricsSummaryResult;

export function prefetchGetUserMetricsSummary(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetUserMetricsSummaryRequest,
  security?: GetUserMetricsSummarySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetUserMetricsSummaryQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetUserMetricsSummaryQuery(
  client$: GramCore,
  request: GetUserMetricsSummaryRequest,
  security?: GetUserMetricsSummarySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetUserMetricsSummaryQueryData>;
} {
  return {
    queryKey: queryKeyGetUserMetricsSummary({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function getUserMetricsSummaryQueryFn(
      ctx,
    ): Promise<GetUserMetricsSummaryQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryGetUserMetricsSummary(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetUserMetricsSummary(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "telemetry", "getUserMetricsSummary", parameters];
}
